var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { cx } from '@emotion/css';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import format from 'date-fns/format';
/* eslint-disable react/jsx-props-no-spreading */
import React, { memo, useCallback, useState } from 'react';
import { ix } from '../../../../utils/ix';
import { ComplexStaticDateRangePicker, useDefaultRanges } from '../../dateRangePickers';
import { isCustom } from '../../dateRangePickers/ComplexStaticDateRangePicker/ComplexStaticDateRangePicker.service';
import { BaseFilterMenu } from '../BaseFilterMenu';
import { DATE_RANGE_PICKER_FILTER_MENU_DATE_FORMAT } from './DateRangePickerFilterMenu.constants';
import { useStyles } from './DateRangePickerFilterMenu.styles';
export const DateRangePickerFilterMenu = memo(function (_a) {
    var _b;
    var { chipDateFormat, className, id, onCancel, onUpdate, ranges, size, value } = _a, rest = __rest(_a, ["chipDateFormat", "className", "id", "onCancel", "onUpdate", "ranges", "size", "value"]);
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState();
    const defaultRanges = useDefaultRanges();
    const rangesConfiguration = ranges || defaultRanges;
    const fallbackTimestamp = 0;
    const startDate = isCustom(value.type)
        ? format(value.dateRange[0] || fallbackTimestamp, chipDateFormat || DATE_RANGE_PICKER_FILTER_MENU_DATE_FORMAT)
        : null;
    const endDate = isCustom(value.type)
        ? format(value.dateRange[1] || fallbackTimestamp, chipDateFormat || DATE_RANGE_PICKER_FILTER_MENU_DATE_FORMAT)
        : null;
    const handleUpdateClick = useCallback((newValue) => {
        setIsOpen(false);
        if (onUpdate) {
            onUpdate(newValue);
        }
    }, [onUpdate]);
    const handleCancelClick = useCallback(() => {
        setIsOpen(false);
        if (onCancel) {
            onCancel();
        }
    }, [onCancel]);
    const handleClose = useCallback(() => {
        setIsOpen(false);
    }, []);
    const handleChipClick = useCallback(() => {
        setIsOpen(!isOpen);
    }, [isOpen]);
    const rangeLabel = (_b = rangesConfiguration.find((range) => range.type === value.type)) === null || _b === void 0 ? void 0 : _b.label;
    return (React.createElement("div", { className: cx(className, classes.root), id: id },
        React.createElement(BaseFilterMenu, { chipContent: React.createElement("div", { className: classes.chipContent, id: ix(id, 'chip') },
                React.createElement(CalendarTodayOutlinedIcon, { className: classes.chipContentIcon, fontSize: "small" }),
                React.createElement("span", { className: classes.chipContentDatesLabel }, "Dates"),
                React.createElement("span", { id: ix(id, 'chip', 'date'), className: classes.chipContentDatesLabelValue }, isCustom(value.type) || !rangeLabel ? `${startDate} - ${endDate}` : rangeLabel),
                isOpen ? React.createElement(ExpandLessIcon, { fontSize: "small" }) : React.createElement(ExpandMoreIcon, { fontSize: "small" })), menuContent: React.createElement(ComplexStaticDateRangePicker, Object.assign({ className: cx(className, classes.menuContent, 'menu'), disableFuture: true, id: ix(id, 'menu'), onCancel: handleCancelClick, onUpdate: handleUpdateClick, ranges: ranges, value: value }, rest)), onChipClick: handleChipClick, onClose: handleClose, open: isOpen, size: size })));
});
//# sourceMappingURL=DateRangePickerFilterMenu.js.map